import React from "react";
import InputBox from "src/business-types/grocery/components/InputBox";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

export interface FormFieldProps {
  id: string;
  label: React.ReactNode;
  value: string;
  onChange: (val: string) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  refProp?: React.Ref<HTMLInputElement>;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  type?: "text" | "select";
  options?: { label: string; value: string }[];
  onlyNumber?: boolean;
}

const FormField: React.FC<FormFieldProps> = ({ id, label, value, onChange, onKeyPress, refProp, disabled = false, error = false, helperText, type = "text", options = [], onlyNumber = false }) => {
  return (
    <div className="w-full mb-2">
      {/* Label */}
      <label className="text-sm font-medium mb-1 block">{label}</label>

      {/* TEXT → InputBox */}
      {type === "text" && <InputBox ref={refProp} value={value} disabled={disabled} error={error} onlyNumber={onlyNumber} onKeyDown={onKeyPress} onChange={(e) => onChange(e.target.value)} />}

      {/* SELECT → CustomDropdownSelect */}
      {type === "select" && (
        <CustomDropdownSelect
          name={id}
          titleofSelect={`Select ${id}`}
          value={value}
          disabled={disabled}
          options={options.map((opt) => ({
            _id: opt.value,
            CategoryName: opt.label,
          }))}
          onChange={(val) => onChange(val)}
        />
      )}

      {/* Helper Text */}
      {helperText && <p className="text-xs text-red-500 mt-1">{helperText}</p>}
    </div>
  );
};

export default FormField;
